/* eslint-disable */
import type { SVGProps } from 'react';
import { memo } from 'react';

const HB = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="600"
    height="400"
    viewBox="0 0 12 8"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 0H12V8H0"
    />
    <path
      fill="#d00"
      d="M0 0h1V8h1V0H12v1H0v1H12v1H0v1H12v1H0v1H12v1H0"
    />
  </svg>
);
export default memo(HB);
